module.exports = __webpack_public_path__ + "img/landing-invest-reviews.34103901.svg";